import { Sparkles } from "lucide-react";
import { useLandingPageContext } from "@/hooks/useLandingPageContext";

const LandingFooter = () => {
  const { generateTestId, generateId } = useLandingPageContext();
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-dark-bg-primary to-dark-bg-secondary border-t border-dark-border">
      <div className="container mx-auto px-4 sm:px-6 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10 md:gap-12 mb-8 sm:mb-10 md:mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img alt="AuraCode Logo" src="/lovable-uploads/b922e941-ba23-47fb-be9f-50db1c876345.png" className="h-12 w-auto filter brightness-0 invert" width={192} height={48} loading="lazy" decoding="async" />
            </div>
            <p className="text-gray-300 leading-relaxed mb-6 max-w-md">
              Tecnologia exclusiva em numerologia cabalística com entrega instantânea de mapas numerológicos personalizados.
            </p>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-3">
              <li><button onClick={() => scrollToSection('hero')} className="text-gray-300 hover:text-dark-accent transition-colors" data-testid={generateTestId('footer-nav', 'hero')}>Início</button></li>
              <li><button onClick={() => scrollToSection('sobre')} className="text-gray-300 hover:text-dark-accent transition-colors" data-testid={generateTestId('footer-nav', 'sobre')}>Sobre</button></li>
              <li><button onClick={() => scrollToSection('bonus')} className="text-gray-300 hover:text-dark-accent transition-colors" data-testid={generateTestId('footer-nav', 'bonus')}>Bônus</button></li>
              <li><button onClick={() => scrollToSection('precos')} className="text-gray-300 hover:text-dark-accent transition-colors" data-testid={generateTestId('footer-nav', 'precos')}>Preços</button></li>
              <li><button onClick={() => scrollToSection('depoimentos')} className="text-gray-300 hover:text-dark-accent transition-colors" data-testid={generateTestId('footer-nav', 'depoimentos')}>Depoimentos</button></li>
              <li><button onClick={() => scrollToSection('faq')} className="text-gray-300 hover:text-dark-accent transition-colors" data-testid={generateTestId('footer-nav', 'faq')}>FAQ</button></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="text-gray-300">Avenida Paulista, 777, Sala 102</li>
              <li className="text-gray-300">São Paulo, SP</li>
              <li className="text-gray-300">CNPJ: 57.787.135/0001-66</li>
              <li><a href="mailto:consultoria@auracode.io" className="text-gray-300 hover:text-dark-accent transition-colors">consultoria@auracode.io</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-dark-border pt-8 text-center">
          <p className="text-gray-400">
            © 2025, feito com ❤️ por AuraCode 🌟
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;